import './styles.scss'; // Archivo de estilos CSS
import { FormControlLabel, Radio } from '@mui/material';
import { SecurityQuestion } from '@src/types/claimsTracker';

interface QuestionListProps {
  title: string;
  questions: SecurityQuestion[];
  selectedAnswers: { [key: number]: boolean };
  onSelectionChange: (questionId: number) => void;
}

export default function QuestionList(props: QuestionListProps): JSX.Element {
  return (
    <>
      {props.questions?.length > 0 && (
        <div className="questionContainer">
          <h2>{props.title}</h2>
          {props.questions.map((question, index) => (
            <div className="questionBox" key={question.questionId}>
              <h3>
                {index + 1}. {question.description}
              </h3>
              <div className="questionResponse">
                <FormControlLabel
                  control={
                    <Radio
                      checked={
                        !!props.selectedAnswers[question.questionId ?? 0]
                      } // Verifica si está seleccionado
                      onClick={() =>
                        props.onSelectionChange(question.questionId ?? 0)
                      } // Alterna estado
                    />
                  }
                  label="RESPUESTA CORRECTA."
                />
                <div className="responseText">{question.answer}.</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
